var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pic"},[_c('img',{attrs:{"src":require("../../assets/404_images/404.png"),"alt":""}}),_c('h2',[_vm._v("哎呀...您访问的页面飞走了！")])])}]

export { render, staticRenderFns }